/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

// Store functionality
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'
import state from './state'

Vue.use(Vuex)

// authentication support
import { vuexOidcCreateStoreModule } from 'vuex-oidc'
import { OidcSettings } from '@/config/oidc'
const atmosSettings = document.atmosSettings;
modules.oidcStore = vuexOidcCreateStoreModule(OidcSettings,
  {
    dispatchEventsOnWindow: false,
  },
  {
    userLoaded: async (user) => {
      //setup axios
      axios.defaults.baseURL = `https://api-${atmosSettings.environment}.softpro.io/`
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token;

      store.dispatch('atmos/init', null, {root:true});
    }
  })

// Create a new store
const store = new Vuex.Store({
  actions,
  getters,
  modules,
  mutations,
  state
})

export default store
